import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Breadcrumb from "../../components/Breadcrumb";
import { Collapse, Button, Row, message } from "antd";
import HotelDropdownComponent from "../../components/HmgHotelDropdown/HotelDropdownComponent";
import {
  bulkfilemappingGetHmgMapping,
  bulkfilemappingCreate,
} from "../../store/actions/index";
import {
  CreateFileMappingTable,
  HmgHotelDropdownElement,
} from "../../components/FileMapping/BulkFileMapping/index";
import { intersection, flattenDeep } from "lodash";

const { Panel } = Collapse;

const buttonDivStyles = { textAlign: "center" };

const breadcrumbElement = (
  <Breadcrumb
    routes={[
      { path: "/", breadcrumbName: "Dashboard" },
      {
        path: "/bulkfilemapping/create",
        breadcrumbName: "Create Bulk File Mapping",
      },
    ]}
  />
);
export class CreateBulkFileNames extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);

    this.state = {
      hmgmainSelect: undefined,
      hmgSelect: undefined,
      allhotels: false,
      hotelSelect: [],
      hmgHotelData: [],
      isreplicate: false,
      replicateHotel: undefined,
      tableData: [],
    };
  }

  changeHotelHandler = (e) => {
    this.setState({
      hotelSelect: e,
    });
  };

  changeAllHotels = (e) => {
    this.setState({
      allhotels: e,
    });
  };

  changeHmgHandler = async (e) => {
    const data = await this.props.bulkfilemappingGetHmgMapping(e);
    // console.log(data,'hmg hotel data')
    this.setState({
      hmgSelect: e,
      allhotels: false,
      hotelSelect: [],
      hmgHotelData: data,
      isreplicate: false,
      replicateHotel: undefined,
      tableData: [],
    });
  };

  hmgmainChange = (e) => {
    this.setState({
      hmgmainSelect: e,
      hmgSelect: undefined,
      allhotels: false,
      hotelSelect: [],
      hmgHotelData: [],
      isreplicate: false,
      replicateHotel: undefined,
      tableData: [],
    });
  };

  handleReplicateCheck = (e) => {
    this.setState({
      isreplicate: e.target.checked,
      replicateHotel: undefined,
      allhotels: false,
      hotelSelect: [],
      tableData: [],
    });
  };

  handleReplicateHotel = (e) => {
    const hoteldata = this.state.hmgHotelData.find((el) => el._id === e);
    // console.log(hoteldata,'hoteldata')
    this.setState({
      tableData: hoteldata.bulk_file_mapping.map((el) => {
        return {
          bulk_source_file_name: el.bulk_source_file_name,
          status: el.status,
        };
      }),
    });
  };

  addRecord = () => {
    const records = [...this.state.tableData];
    records.push({
      bulk_source_file_name: "",
      status: true,
    });
    this.setState({
      tableData: records,
    });
  };

  removeRecord = (index) => {
    const records = [...this.state.tableData];
    records.splice(index, 1);
    this.setState({
      tableData: records,
    });
  };

  updateRecord = (index, type, value) => {
    let records = [...this.state.tableData];
    records[index][type] = value;
    this.setState({
      tableData: records,
    });
  };

  validate = () => {
    if (
      this.state.tableData.filter((el) => el.bulk_source_file_name.length === 0)
        .length > 0
    ) {
      message.error("bulk source file name required");
      return false;
    } else {
      const alreadyAllocatedList = flattenDeep(
        this.state.hmgHotelData
          .filter((hr) => this.state.hotelSelect.includes(hr._id))
          .map((el) => {
            return el.bulk_file_mapping.map((bl) => {
              if (typeof bl.bulk_source_file_name === "string") {
                return bl.bulk_source_file_name.toLowerCase();
              }
            });
          }),
      );

      const inputfileNames = this.state.tableData.map((el) => {
        if (typeof el.bulk_source_file_name === "string") {
          return el.bulk_source_file_name.toLowerCase();
        }
      });

      const commonList = intersection(alreadyAllocatedList, inputfileNames);
      if (commonList.length > 0) {
        message.error(commonList.join(", ") + " already exist");
        return false;
      }
      return true;
    }
  };

  handleSubmit = async () => {
    if (this.validate()) {
      const result = await this.props.bulkfilemappingCreate({
        hotels: this.state.hotelSelect,
        bulkfiles: this.state.tableData,
      });
      if (result) {
        const data = await this.props.bulkfilemappingGetHmgMapping(
          this.state.hmgSelect,
        );
        this.setState({
          tableData: [],
          hmgHotelData: data,
          allhotels: false,
          hotelSelect: [],
          isreplicate: false,
          replicateHotel: undefined,
        });
      }
    }
  };

  render() {
    return (
      <div>
        <div className="container_aa">
          <h3>Create Bulk File Mapping</h3>
          {breadcrumbElement}
        </div>
        <div className="container_ab">
          <Collapse defaultActiveKey={["1"]} expandIconPosition="end">
            <Panel key="1" header="Add Bulk File Mapping">
              <HmgHotelDropdownElement
                hmgmainSelect={this.state.hmgmainSelect}
                hmgmainChange={this.hmgmainChange}
                hmgSelect={this.state.hmgSelect}
                handleHmgChange={this.changeHmgHandler}
                multipleHotels={true}
                allhotelSelect={this.state.allhotels}
                setAllHotels={this.changeAllHotels}
                hotelSelect={this.state.hotelSelect}
                handleHotelChange={this.changeHotelHandler}
                hotellabel={"Hotel Name (s)"}
                handleReplicateCheck={this.handleReplicateCheck}
                isreplicate={this.state.isreplicate}
                hmgHotelData={this.state.hmgHotelData}
                replicateHotel={this.state.replicateHotel}
                handleReplicateHotel={this.handleReplicateHotel}
              />
            </Panel>
          </Collapse>
          <Collapse defaultActiveKey={["2"]} expandIconPosition="end">
            <Panel key="2" header="Bulk File Mapping">
              <CreateFileMappingTable
                tableData={this.state.tableData}
                addRecord={this.addRecord}
                removeRecord={this.removeRecord}
                updateRecord={this.updateRecord}
              />
            </Panel>
          </Collapse>
          <div style={buttonDivStyles}>
            <Button
              type="primary"
              disabled={
                this.state.hmgSelect === undefined ||
                this.state.hotelSelect.length === 0 ||
                this.state.tableData.length === 0
              }
              onClick={this.handleSubmit}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  bulkfilemappingGetHmgMapping: (id) =>
    dispatch(bulkfilemappingGetHmgMapping(id)),
  bulkfilemappingCreate: (data) => dispatch(bulkfilemappingCreate(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateBulkFileNames);
